"use client";

import React from "react";

const variantStyles = {
  primary: "bg-lightCyan/20 text-darkBlue border-lightCyan",
  secondary: "bg-cyanGrey/30 text-darkBlack border-darkGrey",
  success: "bg-statusSucces/20 text-darkBlack border-statusSucces",
  danger: "bg-statusDanger/20 text-darkBlack border-statusDanger",
  warning: "bg-statusWarning/20 text-darkBlack border-statusWarning",
  info: "bg-statusInfo/20 text-darkBlack border-statusInfo",
  light: "bg-lightGrey text-darkBlack border-lightGrey3",
  dark: "bg-darkBlack text-white border-darkBlack",
};

/**
 * Alert - Dismissible or static alert message.
 *
 * @param {string} variant - 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'
 */
export function Alert({
  children,
  variant = "info",
  show = true,
  dismissible = false,
  onClose,
  className = "",
  ...props
}) {
  if (!show) {
    return null;
  }

  const baseStyles =
    "px-4 py-3 rounded border flex items-start gap-3";
  const variantClass = variantStyles[variant] ?? variantStyles.info;

  return (
    <div
      role="alert"
      className={`${baseStyles} ${variantClass} ${className}`.trim()}
      {...props}
    >
      <div className="flex-1">{children}</div>
      {dismissible && onClose && (
        <button
          type="button"
          onClick={onClose}
          className="shrink-0 opacity-70 hover:opacity-100"
          aria-label="Close"
        >
          &times;
        </button>
      )}
    </div>
  );
}
